import React from "react";

const ScenarioComp = (props) => {
  const { name, type, icon } = props;

  return (
    <div className="scenariosList mb-4 d-flex align-items-center justify-content-between px-3">
      <span
        className={`addScenariosIcons d-block rounded-circle
             ${type} text-center`}
      >
        <i className={`icon-${icon} d-block`}></i>
      </span>
      <p className="m-0 fn">{name}</p>
    </div>
  );
};

export { ScenarioComp };
